var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{class:_vm.classes,style:(_vm.style),attrs:{"data-components":"ArrowDropDownSvg","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 8 7"}},[_c('path',{attrs:{"fill":"currentColor","d":"M4.2 6.9L8 .4V0H.2L0 .1a.3.3 0 000 .3l3.8 6.5.2.1.2-.1z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }